<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  template=" <img src='assets/images/spinner.gif' />"
></ngx-spinner>

<div dir="{{languageDir}}">
<div class="content-top-box">
  <ul class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
      <a
        class="breadcrumb-link"
        [routerLink]="breadcrumItem.Url"
        [id]="breadcrumItem.id"
        (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)"
      >
      {{lang.getTransalatedValue(breadcrumItem.text)}}
      </a>
    </li>
  </ul>
</div>

<div class="content">
  <div class="header-title">
    <h1 class="main-title">
      {{langObj ? langObj?.UserLicense : ('UserLicense' | translate)}}
    </h1>
  </div>
  <form name="HeaderForm" [formGroup]="HeaderForm" class="w-100 m-10">
    <div class="w-100 headerForm d-flex">
      <mat-form-field appearence="fill" class="w-27">
        <mat-label>
          {{langObj ? langObj?.Group : ('Group' | translate)}}
        </mat-label>
        <mat-select formControlName="group" (selectionChange)="filterData()">
          <input
            (keyup)="onGroupKey($event.target)"            
            class="form-control w-100"
            placeholder="Search Group"
          />
          <mat-option value="-1">All</mat-option>
          <mat-option *ngFor="let group of GroupList" [value]="group.id">
            {{ group.name }}
          </mat-option>
        </mat-select>
        <mat-error>{{langObj ? langObj?.GroupisRequired : ('GroupisRequired' | translate)}}</mat-error>
      </mat-form-field>
      <button mat-icon-button class="add-button" (click)="openForm('add')">
        <mat-icon class="menu">add</mat-icon>
      </button>

      <!-- <mat-form-field appearance="fill" class="w-20">
        <mat-label>
          {{ langObj ? langObj?.Search : ('Search' | translate) }}
        </mat-label>
        <input matInput type="text" (keyup)="onFilterChanged($event.target)" />
      </mat-form-field> -->

      <div style="margin-top: 20px;"></div>
    </div>
  </form>
</div>
<ag-grid-angular
  style="width: 70%; height: 30vw;"
  class="ag-theme-alpine"
  [rowData]="rowData"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
  [gridOptions]="gridOptions"
  [pagination]="true"
  [paginationPageSize]="10"
  [frameworkComponents]="frameworkComponents"
></ag-grid-angular>
<ng-template #AddBatch>
  <div mat-dialog-title class="mat-title">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="main-title">{{langObj ? langObj?.UserLicenseData : ('UserLicenseData' | translate)}}</h1>
      <button
        mat-mini-fab
        mat-button
        mat-dialog-close
        color="warn"
        title="close"
      >
        <i class="fa fa-times" style="color: #fff;"></i>
      </button>
    </div>
  </div>

  <form name="HeaderForm" [formGroup]="userLicenseForm" class="w-100">
    <div class="w-100 headerForm d-flex">
      <mat-form-field appearence="fill" class="w-45">
        <mat-label>
          {{langObj ? langObj?.Module : ('Module' | translate)}}
        </mat-label>
        <mat-select formControlName="module">
          <input
            (keyup)="onModulekey($event.target)"           
            class="form-control w-100"
            placeholder="Search Module"
          />
          <mat-option
            *ngFor="let module of moduleList"
            [value]="module.moduleId"
          >
            {{ module.moduleName }}
          </mat-option>
        </mat-select>
        <mat-error>{{langObj ? langObj?.ModuleisRequired : ('ModuleisRequired' | translate)}}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="field-fill">
        <mat-label>{{langObj ? langObj?.NoOfLicense : ('NoOfLicense' | translate)}}</mat-label>
        <input
          [readonly]="false"
          type="number"
          matInput
          class="input-text"
          formControlName="noOfLicense"
          autocomplete="off"
        />
        <mat-error>{{langObj ? langObj?.NoOfLicenseisRequired : ('NoOfLicenseisRequired' | translate)}}</mat-error>
      </mat-form-field>
    </div>
    <div mat-dialog-actions class="bottom-buttons mr-3">
      <button type="submit" (click)="saveuserLicesneFormData()">{{langObj ? langObj?.Save : ('Save' | translate)}}</button>

      <button mat-dialog-close>{{langObj ? langObj?.Cancel : ('Cancel' | translate)}}</button>
    </div>
  </form>
</ng-template>
</div>